export default [
  {
    id: 1,
    path: "/assets/img/custom-equipment-button/1.png",
  },
  {
    id: 2,
    path: "/assets/img/custom-equipment-button/2.png",
  },
  {
    id: 3,
    path: "/assets/img/custom-equipment-button/3.png",
  },
  {
    id: 4,
    path: "/assets/img/custom-equipment-button/4.png",
  },
  {
    id: 5,
    path: "/assets/img/custom-equipment-button/5.png",
  },
  {
    id: 6,
    path: "/assets/img/custom-equipment-button/6.png",
  },
  {
    id: 7,
    path: "/assets/img/custom-equipment-button/7.png",
  },
  {
    id: 8,
    path: "/assets/img/custom-equipment-button/8.png",
  },
  {
    id: 9,
    path: "/assets/img/custom-equipment-button/9.png",
  },
  {
    id: 10,
    path: "/assets/img/custom-equipment-button/10.png",
  },
  {
    id: 11,
    path: "/assets/img/custom-equipment-button/11.png",
  },
  {
    id: 12,
    path: "/assets/img/custom-equipment-button/12.png",
  },
  {
    id: 13,
    path: "/assets/img/custom-equipment-button/13.png",
  },
  {
    id: 14,
    path: "/assets/img/custom-equipment-button/14.png",
  },
  {
    id: 15,
    path: "/assets/img/custom-equipment-button/15.png",
  },
  {
    id: 16,
    path: "/assets/img/custom-equipment-button/16.png",
  },
  {
    id: 17,
    path: "/assets/img/custom-equipment-button/17.png",
  },
  {
    id: 18,
    path: "/assets/img/custom-equipment-button/18.png",
  },
  {
    id: 19,
    path: "/assets/img/custom-equipment-button/19.png",
  },
  {
    id: 20,
    path: "/assets/img/custom-equipment-button/20.png",
  },
  {
    id: 21,
    path: "/assets/img/custom-equipment-button/21.png",
  },
  {
    id: 22,
    path: "/assets/img/custom-equipment-button/22.png",
  },
  {
    id: 23,
    path: "/assets/img/custom-equipment-button/23.png",
  },
  {
    id: 24,
    path: "/assets/img/custom-equipment-button/24.png",
  },
  {
    id: 25,
    path: "/assets/img/custom-equipment-button/25.png",
  },
  {
    id: 26,
    path: "/assets/img/custom-equipment-button/26.png",
  },
  {
    id: 27,
    path: "/assets/img/custom-equipment-button/27.png",
  },
  {
    id: 28,
    path: "/assets/img/custom-equipment-button/28.png",
  },
  {
    id: 29,
    path: "/assets/img/custom-equipment-button/29.png",
  },
  {
    id: 30,
    path: "/assets/img/custom-equipment-button/30.png",
  },
  {
    id: 31,
    path: "/assets/img/custom-equipment-button/31.png",
  },
  {
    id: 32,
    path: "/assets/img/custom-equipment-button/32.png",
  },



  {
    id: 34,
    path: "/assets/img/app-icons/kd.png",
  },
  {
    id: 35,
    path: "/assets/img/app-icons/Lk.png",
  },
  {
    id: 36,
    path: "/assets/img/app-icons/df.png",
  },
  {
    id: 37,
    path: "/assets/img/app-icons/mU1.png",
  },
  {
    id: 40,
    path: "/assets/img/app-icons/Aq.png",
  },
  {
    id: 41,
    path: "/assets/img/app-icons/mU1.png",
  },
  {
    id: 42,
    path: "/assets/img/app-icons/16.png",
  },
  {
    id: 43,
    path: "/assets/img/app-icons/uF.png",
  },
  {
    id: 44,
    path: "/assets/img/app-icons/FF.png",
  },
  {
    id: 45,
    path: "/assets/img/app-icons/hI.png",
  },
  {
    id: 46,
    path: "/assets/img/app-icons/7u.png",
  },
  {
    id: 47,
    path: "/assets/img/app-icons/ew.png",
  },
  {
    id: 48,
    path: "/assets/img/app-icons/6n.png",
  },
  {
    id: 49,
    path: "/assets/img/app-icons/KH.png",
  },
  {
    id: 50,
    path: "/assets/img/app-icons/an.png",
  },
  {
    id: 51,
    path: "/assets/img/app-icons/KG.png",
  },
  {
    id: 52,
    path: "/assets/img/app-icons/am.png",
  },
  {
    id: 53,
    path: "/assets/img/app-icons/qH.png",
  },
  {
    id: 54,
    path: "/assets/img/app-icons/ap.png",
  },
  {
    id: 55,
    path: "/assets/img/app-icons/qG.png",
  },
  {
    id: 56,
    path: "/assets/img/app-icons/6m.png",
  },
  {
    id: 57,
    path: "/assets/img/app-icons/0t.png",
  },
  {
    id: 58,
    path: "/assets/img/app-icons/qE.png",
  },
  {
    id: 59,
    path: "/assets/img/app-icons/rdy.png",
  },
  {
    id: 60,
    path: "/assets/img/custom-equipment-button/32.png",
  },
  {
    id: 61,
    path: "/assets/img/custom-equipment-button/32.png",
  },
];
